import { Trans } from '@lingui/macro'

import * as React from 'react'

import { AmountControl } from '~ui/components/formElements/AmountControl/AmountControl'
import { Box, GridRow } from '~ui/components/layout/Box'
import { Text } from '~ui/components/typography/Text/Text'

import { useLayoutCtx } from '../../../config/contexts/LayoutProvider'
import { useProductDetailCtx } from '../contexts/ProductDetailProvider'
import {
  useProductDetailStateCtx,
  useUpdateProductDetailCtx,
} from '../contexts/ProductDetailStateProvider'

type TProps = NoChildren & {
  canCreateOrder?: boolean
}

/**
 * Amount control for a product detail.
 * Allows to add multiple times the same product to the cart.
 */
export const ProductDetailAmountControl: React.FC<TProps> = ({ canCreateOrder = true }) => {
  const { isEditingItem, product } = useProductDetailCtx()
  const { updateProductAmount } = useUpdateProductDetailCtx()
  const { productAmount, isLoading } = useProductDetailStateCtx()
  const { isMobile, isTablet } = useLayoutCtx()

  // the product is sold out OR cart can't be edited (read-only menu)
  if (!canCreateOrder || product?.isSoldOut) {
    return null
  }

  if (productAmount === null) {
    return null
  }

  return (
    <GridRow
      alignItems={`center`}
      columnGap={`medium`}
      justifyContent={isMobile ? `space-between` : `start`}
    >
      {!isTablet && !isEditingItem && (
        <Text fontStyle={`regular`} contrast={`low`}>
          <Trans>add multiple times</Trans>
        </Text>
      )}

      <Box minWidth={`8rem`}>
        <AmountControl
          highlightChange
          initialValue={1}
          value={productAmount}
          showSkeleton={isLoading}
          isDisabled={isEditingItem} // TODO add better UI/UX ?
          onChange={(amount) => updateProductAmount({ amount })}
        />
      </Box>
    </GridRow>
  )
}
